






















































































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import {
  SwExpandableTextfield,
  SwTextfield,
} from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import {
  SwTable,
  TableColumnConfig,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { Prop, Watch } from 'vue-property-decorator';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import RegexValidators from '@/shared/regex-validators';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import ManageAlternateemailStep2 from './manage-alternateemail-step2.vue';

const cssPrefix = 'manage-alternateemail';
@Component({
  components: {
    ...UUIFComponent,
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwDropMenu,
    SwModalBody,
    SwIconButton,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwExpandableTextfield,
    SwCheckbox,
    SwTable,
    SwIcon,
    ManageAlternateemailStep2,
  },
})
export default class ManageAlternateemail extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  modalTitle = '';
  isSubmitted: boolean = false;

  @Prop({ required: true })
  captureATPEmail: any;

  @Watch('captureATPEmail', { immediate: true })
  handleCaptureATPEmail(data: any) {
    this.basicRawData = data || {};
    this.basicData = data || {};
  }

  basicData: any[] = [];
  basicRawData: any[] = [];
  basicData2: any[] = [];
  selectedBasicTableDataRows: any[] = [];
  basicInitSelectedIds: any[] = [];
  emailValidator = new RegExp(RegexValidators.email);
  page1: boolean = true;
  menuOpened: boolean = false;
  appliedFilter: any = [];
  showFilterSearch: boolean = false;
  textExpanded: boolean = false;
  search: string = '';
  showSearchedTextInHeader: boolean = false;
  filterSearch: string = '';
  searchInputChips: any[] = [];
  filterSearchConfig: any = {
    isEnableFilterSearch: false,
    filterSearchKey: '',
    filterSearchOption: '',
    filterSearchLabel: '',
  };
  globalSearchConfig: any = {
    isGlobalSearch: false,
    globalSearchKey: '',
  };

  get filterItems(): DropMenuItem[] {
    return [
      {
        id: 'name',
        content: this.$t('products.name').toString(),
      },
      {
        id: 'emailAddress',
        content: this.$t('altenateEmail.addAlternateEmail').toString(),
      },
      {
        id: 'serialNumber',
        content: this.$t('products.serialnumber').toString(),
      },
    ];
  }

  get basicTableData() {
    return this.basicData?.map((ele: any) => {
      return { ...ele, _key: ele?.serialNumber };
    });
  }

  get basicColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'selection',
        type: 'selection',
      },
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'name',
        dataKey: 'name',
        title: this.$t('products.name').toString(),
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: this.$t('products.serialnumber').toString(),
      },
      {
        key: 'emailAddress',
        dataKey: 'emailAddress',
        title: this.$t('altenateEmail.addAlternateEmail').toString(),
      },
    ];
  }

  closeDialog() {
    this.$emit('close-modal');
  }

  handleSearchFilter() {
    if (this.globalSearchConfig?.globalSearchKey !== '') {
      this.searchInputChips.push(this.globalSearchConfig?.globalSearchKey?.trim());
      this.applyAllFilters();
      this.globalSearchConfig.isGlobalSearch = true;
    }
    this.textExpanded = !this.textExpanded;
  }

  removeInputChip(index: any) {
    this.searchInputChips.splice(index, 1);
    this.globalSearchConfig.globalSearchKey = '';
    this.applyAllFilters();
  }

  addFilterKey(event: any) {
    if (event.code === 'Enter' && this.filterSearchConfig.filterSearchKey !== '') {
      this.searchInputChips.push(this.filterSearchConfig.filterSearchKey.trim());
      this.applyAllFilters(this.filterSearchConfig.filterSearchOption);
      this.filterSearchConfig.filterSearchKey = '';
      this.filterSearchConfig.filterSearchLabel = '';
      this.filterSearchConfig.isEnableFilterSearch = false;
    }
  }

  applyAllFilters(option: any = 'all') {
    const data: any[] = [...this.basicRawData];
    const filteredData: any[] = [];
    this.$store.commit('startLoading');
    if (this.searchInputChips?.length === 0) {
      this.basicData = [...data];
      this.$store.commit('stopLoading');
      return;
    }
    this.searchInputChips?.forEach((searchKey: string) => {
      if (option === 'all') {
        filteredData.push(
          ...data?.filter((element: any) => {
            // tslint:disable:newline-per-chained-call
            return (
              element?.name?.toLowerCase()?.indexOf(searchKey?.toLowerCase()) > -1 ||
              element?.serialNumber?.toLowerCase()?.indexOf(searchKey?.toLowerCase()) > -1 ||
              element?.emailAddress?.toLowerCase()?.indexOf(searchKey?.toLowerCase()) > -1
            );
          }),
        );
      } else {
        filteredData.push(
          ...data.filter((element: any) => {
            return element[option].indexOf(searchKey) > -1;
          }),
        );
      }
    });
    this.basicData = [...filteredData];
    this.$store.commit('stopLoading');
  }

  onRemoveAllFilters() {
    this.globalSearchConfig = {
      isGlobalSearch: false,
      globalSearchKey: '',
    };
    this.filterSearchConfig = {
      isEnableFilterSearch: false,
      filterSearchKey: '',
      filterSearchOption: '',
      filterSearchLabel: '',
    };
    this.searchInputChips = [];
    this.applyAllFilters();
  }

  onSelectMultiItem(option: any) {
    this.menuOpened = !this.menuOpened;
    this.filterSearchConfig.isEnableFilterSearch = true;
    this.filterSearchConfig.filterSearchOption = option;
    this.filterSearchConfig.filterSearchLabel = this.filterItems.filter(ele => ele.id.toString() === option)[0]?.content;
    setTimeout(() => {
      const filterInput = document.getElementById('filtersearch') as HTMLElement;
      if (filterInput) {
        filterInput.children[0].getElementsByTagName('input')[0].focus();
      }
    // tslint:disable-next-line
    }, 200);
  }

  goBack() {
    this.page1 = true;
    const tempInitSeletedIds = this.selectedBasicTableDataRows;
    this.selectedBasicTableDataRows = [];
    this.basicInitSelectedIds = tempInitSeletedIds;
  }

  addAlternateEmail() {
    this.basicData2 = this.basicData
      ?.map((ele: any) => {
        return (
          this.selectedBasicTableDataRows?.includes(ele?.serialNumber) && {
            ...ele,
            emailAddress: ele?.emailAddress === '--' ? '' : ele?.emailAddress,
          }
        );
      })
      ?.filter(Boolean);
    this.page1 = false;
  }

  onEntrySelecting(event: any) {
    if (event?.selecting) {
      this.selectedBasicTableDataRows.push(event?.entryKey);
    } else {
      const indexToRemove = this.selectedBasicTableDataRows?.findIndex(
        (ele: any) => ele === event?.entryKey,
      );
      this.selectedBasicTableDataRows.splice(indexToRemove, 1);
    }
  }
}
